import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {SITE_ISSUES_LIST, SITE_STAGES, SAVE_STAGES_DOCUMENTS} from './type';

export const getSiteStage = (sideId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteStage}?site_id=${sideId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SITE_STAGES, payload: data.response.data });
    return true;
  }
};

export const siteStageStatus = (sideId,status,remark, siteHoldReason) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteStageStatus}?site_id=${sideId}&status=${status}&remark=${remark}&hold_reason=${siteHoldReason}`
  );
  if (res) {
    const { data } = res;
    return res;
  }else{
    return true;
  }
};


export const siteUnhold = (sideId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteUnhold}?site_id=${sideId}`
  );
  if (res) {
    const { data } = res;
    return res;
  }else{
    return true;
  }
};


// siteDismantle
export const siteDismantle = (sideId,status,remark,hold_reason=null) => async (dispatch) => {
  if(status == 31 || status == 34){
    const res = await callWebService(
      callTypes.post,
      '',
      `${Config.installation.siteLERT}?site_id=${sideId}&hold_reason=${hold_reason}&status=${status}&remark=${remark}`
    );
    if (res) {
      const { data } = res;
      return res;
    }else{
      return true;
    }
  }else{
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.siteDismantle}?site_id=${sideId}&hold_reason=${hold_reason}&status=${status}&remark=${remark}`
    );
    if (res) {
      const { data } = res;
      return res;
    }else{
      return true;
    }
  }
  
};

// save site issues
export const saveSiteIssues = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveSiteIssue}`
  );
  if (res) {
    return res;
  } else {
    return true;
  }
};

//Get issues list
export const getIssuesList = (sideId,page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteIssues}?site_id=${sideId}&page=${page}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    dispatch({ type: SITE_ISSUES_LIST, payload: payload?.data ?? outer?.data });
    return true;
  }
};

export const saveStagesDocuments = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.installation.insertDocumentsStageData
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_STAGES_DOCUMENTS, payload: data.response.data });
    return data.response.data;
  }
};